import { ChevronRight } from 'lucide-react'

import footerLogoIcon from '../../assets/footer-logo.png'
import cestaIcon from '../../assets/images/0e1f7e6961ff8fced5d8c8435be2e7297ef27dd8.png'
import tiktokIcon from '../../assets/images/0f8ed882493ad687e8a9e1a3c7798a80db2375c0.png'
import imageIcon from '../../assets/images/2a403d02-7537-4f44-b0d8-fda60e567246.png'
import linkedinIcon from '../../assets/images/39804bcaddd072745d5fd4d4e88a989a04d7f548.png'
import whatsappIcon from '../../assets/images/4976e750a4a5f07b47e1c367de2ecedda1acc028.png'
import facebookIcon from '../../assets/images/64c72febb13a8a57d0e7adc3735d9e6ac5647c1e.png'
import youtubeIcon from '../../assets/images/a78ecea6fb87091433dc3e655d15da330624c4c2.png'
import twitterIcon from '../../assets/images/b1eee532a2f559666c63d64d8ff0a015734d60a1.png'
import cryptoIcon from '../../assets/images/c32e06730a0ec7411c09abd944196cb6daece092.png'
import instagramIcon from '../../assets/images/cea8e16ba751a614a994c7613951f42fb4e1e7b6.png'
import variableIcon from '../../assets/images/fe2d032af027d01e2db6dc522de49aef738f6579.png'

const cardsData = [
  {
    icon: cestaIcon,
    title: 'Cesta Inteligente',
    description:
      'Invista em um portfólio de criptoativos selecionados por especialistas',
    buttonText: 'Saiba mais',
  },
  {
    icon: variableIcon,
    title: 'Renda Variável Digital',
    description: 'Oportunidades inovadoras com retornos exponenciais.',
    buttonText: 'Saiba mais',
  },
  {
    icon: cryptoIcon,
    title: 'Criptomoedas',
    description: 'Mais de 260 opções para você investir.',
    buttonText: 'Saiba mais',
  },
  {
    icon: imageIcon,
    title: 'Renda Fixa Digital',
    description: 'Estabilidade, alto retorno e previsibilidade.',
    buttonText: 'Saiba mais',
  },
]

const socialIcons = [
  { icon: whatsappIcon, alt: 'WhatsApp' },
  { icon: instagramIcon, alt: 'Instagram' },
  { icon: facebookIcon, alt: 'Facebook' },
  { icon: youtubeIcon, alt: 'YouTube' },
  { icon: linkedinIcon, alt: 'LinkedIn' },
  { icon: twitterIcon, alt: 'Twitter' },
  { icon: tiktokIcon, alt: 'TikTok' },
]

const Footer = () => {
  return (
    <footer className="bg-black w-full h-full text-white">
      <div className="container mx-auto px-4 py-12">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Potencialize a sua carteira de investimentos
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="bg-white text-black p-6 rounded-lg shadow-md"
            >
              <img
                src={card.icon}
                alt={card.title}
                width={40}
                height={40}
                className="mb-4"
              />
              <h3 className="text-xl font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600 mb-4">{card.description}</p>
              <button
                type="button"
                className="flex items-center justify-center bg-gray-200 text-black px-4 py-2 rounded-full hover:bg-gray-300 transition"
              >
                <ChevronRight className="mr-2 h-5 w-5" />
                {card.buttonText}
              </button>
            </div>
          ))}
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 lg:gap-12 3xl:gap-16">
          <div className="flex flex-col items-center justify-center">
            <img src={footerLogoIcon} alt="logo vilaPay" />
            <h2 className="text-3xl font-bold mb-4">Symbank</h2>
          </div>
          <div>
            <div className="text-center mb-8">
              <h3 className="text-2xl font-semibold mb-4">
                Acompanhe nossas redes sociais:
              </h3>
              <div className="flex justify-center space-x-4">
                {socialIcons.map((social, index) => (
                  <img
                    key={index}
                    src={social.icon}
                    alt={social.alt}
                    width={40}
                    height={40}
                    className="cursor-pointer hover:opacity-80 transition"
                  />
                ))}
              </div>
            </div>

            <div className="text-center">
              <p className="text-xl">
                Symbank Invest 2024. Todos os direitos reservados
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
